module.exports = __webpack_public_path__ + "static/gin-2-41d5b7792c5c1056f1543b0fa1994ffd.jpg";